import { useEffect, useRef, useState } from "react";

export default function HowItWorks() {
  const cards = [
    {
      step: "Step 01",
      title: "Share your brief",
      desc:
        "Tell us about your brand, quantity, timeline, and where the apparel will be worn.",
      img: "Website-assests/step1.png",
    },
    {
      step: "Step 02",
      title: "Design & sampling",
      desc:
        "We create designs, mockups and samples until everything feels right.",
      img: "Website-assests/step2.png",
    },
    {
      step: "Step 03",
      title: "Production & delivery",
      desc:
        "Your order goes into production and is delivered ready to wear.",
      img: "Website-assests/step3.png",
    },
  ];

  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="how-wrapper">
      <div className="title-wrap">
        <h2
          style={{
            fontFamily: "'PP Neue Montreal', sans-serif",
            fontWeight: 400,
            fontSize: "clamp(36px, 4.5vw, 60px)",
            lineHeight: "1.0",
            letterSpacing: "0.05em",
            color: "#0b0b0b",
          }}
        >
          <span style={{ display: "block" }}>A Clear Process</span>
          <span style={{ display: "block" }}>No Guesswork.</span>
        </h2>
      </div>

      <div className="content">
        <div className="card">
          {cards.map((item, index) => (
            <div
              key={index}
              className={`panel ${visible ? "show" : ""}`}
              style={{ transitionDelay: `${index * 0.45}s` }}
            >
              <img className="card-image" src={item.img} alt={item.title} />

              <div className="text-wrap">
                <span className="step">{item.step}</span>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .how-wrapper {
          width: 100%;
          background: #ffffff;
          padding: 0vh 4vw 3vw;
        }

        .title-wrap {
          text-align: center;
          margin-bottom: 40px;
        }

        .content {
          display: flex;
          justify-content: center;
        }

        .card {
          width: 100%;
          max-width: 1280px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 56px;
        }

        .panel {
          background: #f2f3f5;
          border-radius: 18px;
          overflow: hidden;
          opacity: 0;
          transform: translateY(90px);
          transition:
            opacity 1.6s cubic-bezier(0.22,1,0.36,1),
            transform 1.6s cubic-bezier(0.22,1,0.36,1);
        }

        .panel.show {
          opacity: 1;
          transform: translateY(0);
        }

        .panel:hover {
          transform: translateY(-6px);
          box-shadow: 0 26px 52px rgba(0,0,0,0.16);
        }

        /* REDUCED IMAGE HEIGHT */
        .card-image {
          width: 100%;
          height: clamp(240px, 24vw, 300px);
          object-fit: contain;
          display: block;
        }

        /* REDUCED TEXT PADDING */
        .text-wrap {
          padding: 22px 24px 26px;
        }

        .step {
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.08em;
          color: #fe7814;
          margin-bottom: 8px;
          display: inline-block;
        }

        .text-wrap h3 {
          font-size: 20px;
          margin-bottom: 8px;
          color: #000;
        }

        .text-wrap p {
          font-size: 15px;
          line-height: 1.5;
          color: #555;
        }

        @media (max-width: 640px) {
  .card {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .how-wrapper {
    padding: 6vh 5vw 8vh;
  }
}

      `}</style>
    </section>
  );
}
